function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.896 26.174a1.219 1.219 0 10-1.353 2.028 1.219 1.219 0 001.353-2.028zM10.896 26.174a1.219 1.219 0 10-1.353 2.028 1.219 1.219 0 001.353-2.028zM28.125.66h-1.23a2.622 2.622 0 00-2.588 2.184l-.584 3.432H2.813a1.683 1.683 0 00-1.331.649 1.684 1.684 0 00-.307 1.449l1.812 7.25a4.502 4.502 0 004.365 3.408h14.2l-.542 3.188a1.12 1.12 0 01-1.109.937H7.5a.75.75 0 000 1.5h12.401a2.622 2.622 0 002.588-2.186l.69-4.055.003-.015 2.604-15.304 1.109-.936-1.109.936a1.13 1.13 0 011.11-.936h1.23A.75.75 0 1028.125.66zm-6.317 16.871H7.353a3.003 3.003 0 01-2.91-2.271L2.63 8.009a.188.188 0 01.183-.233h20.655l-1.66 9.755z"
}))));